// useGoogleTranslate.js
import { useEffect } from 'react'

export function useGoogleTranslate() {
  useEffect(() => {
    const handleMutation = (mutations: MutationRecord[]) => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          // Verificar e corrigir manipulações indesejadas do DOM
        }
      })
    }

    const observer = new MutationObserver(handleMutation)
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    return () => observer.disconnect()
  }, [])
}
